export const HOME_PAGE_ROUTE = '/';
export const IDENTIFICATION_PAGE_ROUTE = '/identification';
export const CONTAINERIZATION_PAGE_ROUTE = '/containerization';
export const PRINT_PAGE_ROUTE = '/print';
export const RECEIVE_PAGE_ROUTE = '/receive';
export const MOVE_PAGE_ROUTE = '/move';
export const SEND_TO_PROCESS_PAGE_ROUTE = '/send';
export const SEARCH_PAGE_ROUTE = '/search';
export const SUB_SORT_PAGE_ROUTE = '/sort';
export const UNLOAD_PAGE_ROUTE = '/unload';
export const UNLOAD_TRAILER_PAGE_ROUTE = '/unload-trailer';
export const UNLOAD_PALLET_PAGE_ROUTE = '/unload-pallet';
export const UNLOAD_RESOLVE_PAGE_ROUTE = '/unload-resolve';
